import type { FunctionComponent } from "react"

import Image from "next/image"

import { Paper } from "@jobteaser/ui-kit/components/Paper/Paper"

import styles from "./CompanyLogo.module.css"

type logoUrlType = {
  logoUrl: string
}

export const CompanyLogo: FunctionComponent<logoUrlType> = ({ logoUrl }) => (
  <Paper className={styles.companyLogo__wrapper} noSpacing>
    <Image alt="" src={logoUrl} height="80" width="80" />
  </Paper>
)
